import { apiClient, API_CONFIG } from '@/api/core';
import { buildQueryString } from '@/api/shared';
import type { ApiResponse } from '@/api/shared';
import type {
  LC_GetSystemPagesOut,
  LC_GetSystemPagesParams,
  LC_GetRoleSectionsOut,
  LC_SetRolePermissionsIn,
  PermissionsFileResult,
} from './rolePermissions.types';


export class RolePermissionsService {
  async getSystemPages(
    params: LC_GetSystemPagesParams,
  ): Promise<ApiResponse<LC_GetSystemPagesOut>> {
    const query = buildQueryString(params);
    return apiClient.get<LC_GetSystemPagesOut>(
      `${API_CONFIG.ENDPOINTS.AUTHORIZATION.SYSTEM_PAGES}${query}`,
    );
  }

  async getRoleSections(
    roleId: number,
    interfaceId: number,
  ): Promise<ApiResponse<LC_GetRoleSectionsOut>> {
    return apiClient.get<LC_GetRoleSectionsOut>(
      API_CONFIG.ENDPOINTS.AUTHORIZATION.ROLE_SECTIONS(roleId, interfaceId),
    );
  }

  async savePermissions(
    roleId: number,
    payload: LC_SetRolePermissionsIn,
  ): Promise<ApiResponse<boolean>> {
    return apiClient.put<boolean>(
      API_CONFIG.ENDPOINTS.AUTHORIZATION.ROLE_PERMISSIONS(roleId),
      payload,
      { skipUnauthorizedHandler: true },
    );
  }

  async exportPermissionsFile(roleId: number): Promise<ApiResponse<PermissionsFileResult>> {
    return apiClient.downloadBlobWithFilename(
      API_CONFIG.ENDPOINTS.AUTHORIZATION.ROLE_PERMISSIONS_FILE(roleId),
      { method: 'GET' },
    );
  }
}

export const rolePermissionsService = new RolePermissionsService();
